import { API } from 'aws-amplify';

const tableName = process.env.VUE_APP_USER_TABLE_NAME;

export default {
  state: {
  },
  list() {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', { body: { operation: 'list', tableName } }).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  read(item) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', {
        body: {
          operation: 'read', tableName, primaryKey: 'email', value: item,
        },
      }).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  create(items, opMode = 'portal') {
    return new Promise((resolve, reject) => {
      const params = { ...items };
      params.opMode = opMode;
      API.post('UserAPI', '', { body: params }).then((response) => {
        if (process.env.VUE_APP_SSO === 'oauth2') params.opMode = 'admin'; // CHERRY_TEST
        // if (window.sessionStorage.getItem('isOauthTest') === 'true')params.opMode = 'admin';// CHERRY_TEST
        else {
          if (!response.created) {
            reject(response.error);
            return;
          }
          params.cognitoId = response.userId;
        }
        params.group = opMode === 'admin' ? 'pass' : 'pending';
        params.createTime = new Date().getTime();
        params.updateTime = new Date().getTime();
        params.packages = 'All';
        params.publishers = 'All';
        params.types = 'All';
        delete params.opMode;
        API.post('API', '/awsDB', { body: { operation: 'create', tableName, item: params } }).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      }).catch((error) => {
        reject(error);
      });
    });
  },
  update(items) {
    return new Promise((resolve, reject) => {
      // items.updateTime = new Date().getTime();
      API.post('API', '/awsDB', {
        body: {
          operation: 'update', tableName, primaryKey: 'email', item: items,
        },
      })
        .then((response) => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  delete(items) {
    return new Promise((resolve, reject) => {
      API.del('UserAPI', `/${items.cognitoId}`).then((response) => {
        API.post('API', '/awsDB', {
          body: {
            operation: 'delete', tableName, primaryKey: 'email', value: items.email,
          },
        }).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  pendingPass(email, items) {
    return new Promise((resolve, reject) => {
      API.get('UserAPI', `/checkPass/${email}`).then(() => {
        this.update(items).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      }).catch((error) => {
        reject(error);
      });
    });
  },
  pendingReject(items, rejectReason) {
    return new Promise((resolve, reject) => {
      const data = { userName: items.email, rejectReason };
      API.post('UserAPI', '/checkReject', { body: data }).then(() => {
        API.post('API', '/awsDB', {
          body: {
            operation: 'delete', tableName, primaryKey: 'email', value: items.email,
          },
        }).then((result) => {
          resolve(result);
        }).catch((error) => {
          reject(error);
        });
      }).catch((error) => {
        reject(error);
      });
    });
  },
  encrypt(items) {
    return new Promise((resolve, reject) => {
      API.post('EcPayAPI', '/encrypt', { body: items, headers: { 'x-api-key': process.env.VUE_APP_API_GATEWAY_ECPAY_APIKEY } }).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};
